export function getInitials(name, size) {
    var _a, _b;
    const initialsArray = [...(name.matchAll(/(\p{L}{1})\p{L}+/gu) || [])];
    let initials = (initialsArray.length > 1
        ? (((_a = initialsArray.shift()) === null || _a === void 0 ? void 0 : _a[1]) || '') + (((_b = initialsArray.pop()) === null || _b === void 0 ? void 0 : _b[1]) || '')
        : name.substring(0, 2)).toUpperCase();
    if (size === 'small') {
        initials = initials.substring(0, 1);
    }
    return initials;
}
//# sourceMappingURL=AvatarUtils.js.map